import React from 'react'
import {
  makeStyles,
  withStyles,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from '@material-ui/core'
import { ReactComponent as ExpandIcon } from '../assets/icons/expand.svg'
import { ReactComponent as CollapseIcon } from '../assets/icons/collapse.svg'
const useStyles = makeStyles((theme) => ({
  list: {
    maxWidth: '100%',

    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
    '& iframe': {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        height: 'auto',
      },
    },
    '& img': {
      width: '100%',
      height: 'auto',
    },
  },
}))
const FaqAccordion = withStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    height: 'auto !important',
    '&.Mui-expanded': {
      margin: 0,
    },
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.contrastText,
    },
    '&:before': {
      display: 'none',
    },
  },
  collapseIcon:{
    display: 'flex',
    justifyContent:"space-between"
  }
}))(Accordion)

const FaqAccordionSummary = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent:"space-between",
    minHeight: 'auto',
    transition: `background-color ease 0.3s`,
    flexDirection: 'row-reverse',
    padding: theme.spacing(2),
    '&.Mui-expanded': {
      minHeight: 'auto',
    },
    '&.Mui-disabled': {
      opacity: 1,
    },
  },
  content: {
    color: theme.palette.grey[900],
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.h5.fontSize,
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
      minHeight: 'auto',
    },
  },
}))(AccordionSummary)

const FaqAccordionDetails = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: 1.5,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 2),
  },
}))(AccordionDetails)

const FaqItem = ({ question, content, onChange, id, activePanel }) => {
  const classes = useStyles()

  const _handleChange = (e, isExpanded) => {
    onChange && onChange(isExpanded ? id : null)
  }

  return (
    <>
      <Box mx={2}>
        <Divider />
      </Box>
      <FaqAccordion
        expanded={activePanel === id}
        onChange={_handleChange}
        TransitionProps={{
          timeout: 300,
        }}
      >
        <FaqAccordionSummary
        position='relative'
        className={classes.collapseIcon}
        // expandIcon={
        //   activePanel === id ? (
        //     <CollapseIcon/>
        //   ) : (
        //     <ExpandIcon/>
        //   )
        // }
        > 
          <Box mt={0.5} width='89%' fontWeight={600} fontSize={18} lineHeight='150%'>
          {question}
          </Box>
          <Box position='absolute' top={16} right={24}>
            {
              activePanel === id ? (
                <CollapseIcon/>
              ) : (
                <ExpandIcon/>
              )
            }
          </Box>
        </FaqAccordionSummary>
        <FaqAccordionDetails>
          <Box className={classes.list}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Box>
        </FaqAccordionDetails>
      </FaqAccordion>

    </>
  )
}

export default FaqItem
